export default __webpack_public_path__ + "static/media/Rock.6ca75872.png";